export default {
  avatar: 'Obrázok služby / Logo',
  callToAction: 'Vyberte druh služby',
  header1: 'Pridať službu k spoločnosti',
  header2: 'Pridať fotky pre službu',
  header3: 'Pridať otváracie hodiny pre službu'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/routes/addService.js